import React, { useEffect, useRef, useState } from "react";
import PageTab from "@/components/i-pageTab/i-pageTab";
import PageTable from "@/components/i-pageTable/i-pageTable";
import {
  getChannelList,
  addChannel,
  editChannel,
  deleteChannel,
  getUserBaseList,
  getChannelDetail,
  exportChannelInfo,
} from "@/api/operation";
import { Button, Form, message, Modal, Space, Tag } from "antd";
import { customRequest, normFile, setIcons, downloadFile, getTimeFormat } from "@/utils/common";
import { useSelector, useDispatch, useStore } from "react-redux";
import { dictInfoAsync } from "@/stores/dictInfo";
import { channelTypeData, columns } from "./helps";
import { channelLevelAreaTree, areaTree } from "@/api/setting";
import { useCascader } from '@/hooks/useCascader';

const ChannelLevelEnum: Record<number, string> = {
  1: "channelProvinceId",
  2: "channelCityId",
  3: "channelDistrictId",
};

const channelLevelData = [
  {
    label: "省级",
    value: 1,
  },
  {
    label: "市级",
    value: 2,
  },
  {
    label: "区级",
    value: 3,
  },
];


export default function ChannelManager() {
  const dispatch = useDispatch();
  const {
    state: { app_store_type },
  } = useSelector((state: { dictInfo: any }) => state.dictInfo);

  const [form] = Form.useForm();

  const [pageData, setPageData] = useState<GetCmsPageHomeRes["rows"]>([]);
  const [total, setTotal] = useState(0);
  const [addProxyOpen, setAddProxyOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [userBaseList, setUserBaseList] = useState<any[]>([]);
  const onceTime = useRef(false);
  const [exportLoading, setExportLoading] = useState(false);
  const [areaOptions, setAreaOptions] = useState<any[]>([]);
  const initAreaOptions = useRef<any[]>([]);
  const timer = useRef<NodeJS.Timeout | null>(null);
  const [modalFormData, setModalFormData] = useState<pageHomeAddParams>({
    status: "0",
    url: [],
  });

  const [formData, setFormData] = useState<any>({
    channelType: undefined,
    ypageNum: 1,
    ypageSize: 10,
    channelStatusList: [1]
  });

  const { cascaderProps, loadByIds } = useCascader({
    fetchData: areaTree as any,
    initId: [100000]
  });

  const formTab = [
    {
      label: "渠道等级",
      name: "channelLevel",
      type: "select",
      options: channelLevelData,
    },
    {
      label: "区域范围",
      name: "channelName",
      type: "cascader",
      params: {
        ...cascaderProps,
        style: {
          width: "180px",
        },
      },
    },
    {
      label: "代理人账号",
      name: "channelAgentMobile",
      type: "input",
    },
    {
      label: "代理类型",
      name: "channelType",
      type: "select",
      options: channelTypeData,
    },
  ];

  const modalFormTabConfig = [
    {
      label: "渠道等级",
      name: "channelLevel",
      rules: [{ required: true, message: "请输入渠道等级" }],
      type: "select",
      options: channelLevelData,
      // params: {
      //   onChange: (val: string) => {
      //     onLevelChange(val);
      //   },
      // },
    },

    {
      label: "区域范围",
      name: "channelName",
      type: "cascader",
      rules: [{ required: true, message: "请输入区域范围" }],
      params: {
        ...cascaderProps,
        onChange: (value: any, selectedOptions: any) => {
          console.log(value, selectedOptions);
        },
        style: {
          width: "180px",
        },
      },
    },
    {
      label: "代理类型",
      name: "channelType",
      type: "select",
      options: channelTypeData,
      notShow: !modalFormData.id,
      rules: [{ required: true, message: "请选择代理类型" }],
    },
    // {
    //   label: "设备目标量",
    //   name: "channelTargetCount",
    //   type: "input",
    //   params: {
    //     type: "number",
    //   },
    //   rules: [
    //     { required: true, message: "请输入正确设备目标量" },
    //     {
    //       validator: (rule: any, value: number, callback: (arg0?: Error | undefined) => void) => {
    //         if (value && (value <= 0 || value % 1 !== 0)) {
    //           callback(new Error("设备目标量必须大于0且为整数"));
    //         }
    //         callback();
    //       },
    //     }
    //   ],
    // },
  ];



  const fetchAreaData = async (id: number, level: number) => {
    try {
      if (level === 0) {
        // let areaData = [];
        const {data} = await areaTree(id);
        const {data: level1Data } = await areaTree(data[0].id) as any;
        const {data: level2Data} = await areaTree(level1Data[0].id);
        level1Data[0].children = level2Data;
        data[0].children = level1Data;
        console.log(data, "data");
        setAreaOptions(data)

      } else {
        const data = await areaTree(id);
        console.log(data, "data");
      }
    } catch (error) {
      console.error("获取区域数据失败:", error);
    }
  };



  const getUserBaseListData = async (val: string) => {
    if (onceTime.current || !val) {
      return;
    }
    setTimeout(() => {
      onceTime.current = false;
    }, 300);

    onceTime.current = true;

    const { data } = await getUserBaseList({ mobile: val });
    console.log(data, "data");
    setUserBaseList(
      data?.map((item: any) => ({ label: item.nickName, value: item.userId }))
    );
  };

  useEffect(() => {
    // 加载初始数据
    areaTree(100000).then(({data}) => {
      setAreaOptions(data.map((item: any) => ({
        label: item.name,
        value: item.id,
        isLeaf: false, // 初始节点都可以展开
      })));
    });
  }, []);

  const addProxyFormTab = [
    {
      label: "代理人账号",
      name: "channelAgentUserId",
      type: "select",
      rules: [{ required: true, message: "请选择代理人账号" }],
      options: userBaseList,
      params: {
        placeholder: "请输入代理人账号",
        showSearch: true,
        filterOption: false,
        defaultActiveFirstOption: false,
        onSearch: (val: string) => {
          getUserBaseListData(val);
        },
      },
    },
    {
      label: "代理人推荐",
      name: "channelAgentRecommendUserId",
      type: "input",

    },
    {
      label: "备注",
      name: "remark",
      type: "textArea",
    },
  ];

  const footer = [
    {
      title: "新增区域",
      icon: setIcons("PlusOutlined"),
      onClick: () => setOpen(true),
    },
    {
      title: "导出",
      icon: setIcons("DownloadOutlined"),
      loading: exportLoading,
      onClick: () => {
        exportChannelList(formData);
      },
    }
  ];

  useEffect(() => {
    getPageData();
  }, [formData]);

  useEffect(() => {
    !app_store_type && dispatch(dictInfoAsync("app_store_type") as any);
  }, []);

  const getPageData = async () => {
    setLoading(true);
    const channelLevel: any = {
      channelCityId: formData.channelName?.[1],
      channelDistrictId: formData.channelName?.[2],
      channelProvinceId: formData.channelName?.[0],
    }
    try {
      const data = await getChannelList({ ...formData, delFlag: "0", ...channelLevel });
      setPageData(data.rows);
      setTotal(data.total);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const deleteOutletsData = async (val: string) => {
    Modal.confirm({
      title: "提示",
      content: "确定删除该渠道吗？",
      onOk: async () => {
        try {
          await deleteChannel(val);
          message.success("删除成功");
          getPageData();
        } catch (error) {}
      },
    });
  };

  const search = (val: any) => {
    setFormData({
      ...formData,
      ...val,
      ypageNum: 1,
    });
  };

  const reset = () => {
    setFormData({
      channelType: undefined,
      ypageNum: 1,
      ypageSize: 10,
      channelStatusList: [1]
    });
  };
  const resetModal = () => {
    form.resetFields();
    
    setModalFormData({
      status: "0",
      url: [],
    });
    setAreaOptions([]);
    setUserBaseList([]);
    setOpen(false);
  };

  const exportChannelList = async (val: any) => {
    try {
      setExportLoading(true);
      const channelLevel: any = {
        channelCityId: val.channelName?.[1],
        channelDistrictId: val.channelName?.[2],
        channelProvinceId: val.channelName?.[0],
      };
      const data = await exportChannelInfo({ ...val, delFlag: "0", ...channelLevel });
      downloadFile(
        data as any,
        "渠道列表导出" + getTimeFormat(new Date(), "yyyy-MM-dd HH:mm:ss")
      );
    } catch (error) {
    } finally {
      setExportLoading(false);
    }
  };

  const confirmSend = async (val: any) => {
    try {
      if (modalFormData.id) {
        await editChannel({
          ...val,
          channelProvinceId: val.channelName?.[0],
          channelCityId: val.channelName?.[1],
          channelDistrictId: val.channelName?.[2],
        });
        message.success("编辑成功");
      } else {
        await addChannel({
          ...val,
          channelProvinceId: val.channelName?.[0],
          channelCityId: val.channelName?.[1],
          channelDistrictId: val.channelName?.[2],
        });
        message.success("新增成功");
      }
      resetModal();
      getPageData();
    } catch (error) {}
  };

  const confirmProxy = async (val: any) => {
    console.log(val, "valvalval");
    Modal.confirm({
      title: "提示",
      content: "添加后无法修改，确定添加吗？",
      onOk: async () => {
        await editChannel({ ...modalFormData, ...val });
        message.success("新增成功");
        resetModal();
        setAddProxyOpen(false);
        setUserBaseList([]);
        getPageData();
      },
    });
  };

  const pageChange = (current: number, pageSize: number) => {
    setFormData({
      ...formData,
      ypageNum: current,
      ypageSize: pageSize,
    });
  };
  return (
    <div>
      <Modal
        destroyOnHidden
        open={addProxyOpen}
        title={"新增代理"}
        width="360px"
        footer={<></>}
        onCancel={() => {
          setAddProxyOpen(false);
        }}
      >
        <PageTab
          subFoot
          search={confirmProxy}
          reset={() => {
            setAddProxyOpen(false);
          }}
          formTab={addProxyFormTab}
        ></PageTab>
      </Modal>

      <Modal
        destroyOnHidden
        open={open}
        title={modalFormData.id ? "编辑渠道" : "新增渠道"}
        width="360px"
        footer={<></>}
        onCancel={resetModal}
      >
        <PageTab
          form={form}
          subFoot
          search={confirmSend}
          reset={resetModal}
          formTab={modalFormTabConfig as any}
          initialValues={modalFormData}
        ></PageTab>
      </Modal>
      <PageTab
        search={search}
        reset={reset}
        formTab={formTab}
        footer={footer}
      ></PageTab>
      <PageTable
        loading={loading}
        pageChange={pageChange}
        size="small"
        rowKey="id"
        columns={columns({
          setModalFormData,
          setOpen,
          deleteOutletsData,
          fetchAreaData,
          setAddProxyOpen,
          loadByIds
        })}
        data={pageData}
        pagination={{
          current: formData.ypageNum!,
          pageSize: formData.ypageSize!,
          total: total,
        }}
      ></PageTable>
    </div>
  );
}
